import { Box, SimpleGrid } from "@chakra-ui/react";
import { Section, Title } from "../utils";
import { PARTNERS_LIST } from "../landingConstants";
import BaseImage from "@components/BaseImage";

const Partners = () => {
  return (
    <Section>
      <Title>
        Private <br /> Sale Partners
      </Title>

      <SimpleGrid
        spacing={{ base: "4px", sm: "8px", md: "12px" }}
        columns={{ base: 3, sm: 4, md: 6 }}
      >
        {PARTNERS_LIST.map((partner) => (
          <Box
            width="100%"
            height={{ base: "64px", sm: "88px", md: "120px" }}
            pos="relative"
            key={partner.key}
          >
            <BaseImage src={partner.imgUrl} alt={partner.key} fill />
          </Box>
        ))}
      </SimpleGrid>
    </Section>
  );
};

export default Partners;
